import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


type Entity = models.ReportePaquetesPPParametros;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGenerar: () => Promise<void>;
    puedeCambiarCliente: boolean;
    permisos: models.Rol;
}

/**
* Componente para editar un Entity
*/
class ReportePaquetesPPNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
        };
    }

    puedeCambiarCliente = (props: Props) => props.puedeCambiarCliente;

    render() {
        const { value, onGenerar } = this.props;
        const getField = this.getField;
        const puedeCambiarCliente = this.puedeCambiarCliente(this.props);

        const DateTime = getField(kea.DateTime);
        const Number = getField(kea.Number);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const VisualizarPaquetes = getField(selectores.VisualizarPaquetes);

        const ReportePaquetesPPVistaVendedores = this.props.permisos.Reportes.ReportePaquetesPPVistaVendedores;
        return (
            <div>
                <kea.Title titulo="Reporte de paquetes de PP" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <Cliente field="IdCliente" label="Cliente" readonly={!puedeCambiarCliente} />,
                    !ReportePaquetesPPVistaVendedores && <Sucursal field="IdSucursal" label="Sucursal" /*readonly={!puedeCambiarCliente}*/ />,
                    !ReportePaquetesPPVistaVendedores && <VisualizarPaquetes field="visualizar" label="Visualizar paquetes" />
                ])}
                 {kea.autogrid(6, [
                    <DateTime field="FechaInicio" label="Fecha inicio" />,
                    <DateTime field="FechaFinal" label="Fecha final" />,
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={onGenerar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const ReportePaquetesPPForm = componentToRx(ReportePaquetesPPNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reportepaquetepp/form.tsx